import React from 'react';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <div className="app-container">
        {children}
      </div>
      <MobileNav />
    </div>
  );
};
